import React, { Component } from "react"
import SbEditable from "storyblok-react"
import PropTypes from "prop-types"
import queryString from "query-string"

const $script = typeof document !== "undefined" ? require("scriptjs") : null

function productCodeFromUrl() {
  const urlString = queryString.parse(document.location.search)
  return urlString.ashStripeProductCode || urlString.ashstripeproductcode
}

class AshridePayment extends Component {
  stripe = null
  marketo = null
  productCode = null
  state = { error: null }

  componentDidMount() {
    this.productCode = productCodeFromUrl()

    if (!this.productCode) {
      this.setState({ error: "ERROR NO SKU PRODUCT CODE" })
    } else {
      if ($script)
        $script(
          [
            "https://js.stripe.com/v3/",
            "https://app-e.marketo.com/js/forms2/js/forms2.min.js",
          ],
          this.onLoad,
          err => {
            console.error(err)
          }
        )
    }
  }

  onLoad = () => {
    const self = this

    const { blok } = this.props
    const skuCode = this.productCode

    this.stripe = window.Stripe(blok.stripePublishableKey)
    this.marketo = window.MktoForms2

    this.marketo.loadForm(
      "//app-e.marketo.com",
      blok.marketoId,
      blok.marketoFormNumber,
      function(form) {
        form.vals(queryString.parse(document.location.search))
        const ashProgram = document.getElementById("ashprogramname")
        if (ashProgram) ashProgram.setAttribute("readonly", "true")
        form.onSuccess(values => {
          self.stripe
            .redirectToCheckout({
              items: [{ sku: skuCode, quantity: 1 }],
              clientReferenceId: values.ASH_Booking_Id__c,
              customerEmail: values.Email,
              successUrl: blok.paymentSuccessUrl.url,
              cancelUrl: blok.paymentFailureUrl.url,
              billingAddressCollection: "required",
            })
            .then(({ error }) => {
              if (error) {
                console.error(error)
              }
            })
            .catch(error => {
              console.error(error)
              self.setState({ error })
            })
          return false
        })
      }
    )
  }

  render() {
    const { blok } = this.props
    return (
      <SbEditable content={blok}>
        {this.state.error !== null ? (
          this.state.error && (
            <div
              style={{
                color: "white",
                fontSize: "20px",
                background: "red",
                margin: "auto",
                padding: "20px",
                textAlign: "center",
                marginBottom: "15px",
                borderRadius: "5px",
              }}
            >
              {this.state.error}
            </div>
          )
        ) : (
          <form id={`mktoForm_${blok.marketoFormNumber}`}></form>
        )}
      </SbEditable>
    )
  }
}

AshridePayment.propTypes = {
  blok: PropTypes.shape({
    stripePublishableKey: PropTypes.string,
    paymentSuccessUrl: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    paymentFailureUrl: PropTypes.shape({
      linktype: PropTypes.string,
      cached_url: PropTypes.string,
      url: PropTypes.string,
    }),
    marketoFormNumber: PropTypes.string,
    marketoId: PropTypes.string,
  }),
}

export default AshridePayment
